import { IUser } from '~/types/user-info-types'

const getSubscriptionFromUser = (
  user: IUser,
): {
  stripeSubscription?: IUser['stripeSubscription']
  validMobileApSubscription?: IUser['validMobileAppSubscription']
} => {
  if (!user.stripeSubscription?.length && !user.validMobileAppSubscription && user?.familyProfiles?.length) {
    const subscription = user.familyProfiles.find(
      (profile) => profile.stripeSubscription || profile.validMobileAppSubscription,
    )

    return {
      stripeSubscription: subscription?.stripeSubscription,
      validMobileApSubscription: subscription?.validMobileAppSubscription,
    }
  }

  return {
    stripeSubscription: user.stripeSubscription,
    validMobileApSubscription: user.validMobileAppSubscription,
  }
}

export { getSubscriptionFromUser as getSubScriptionFromUser }
